import { Facet, Filter, Query } from '@/models/dynamiclist';
import { State } from '@/types';
import { GetterTree } from 'vuex';
import { FacetFilter, FilterQuery } from '../models/dynamiclist';
import { groupByAmount } from '../services/utils';

export const getters: GetterTree<State, any> = {
    error: (state: State) => state.error,
    data: (state: State) => state.data,
    filterRows: (state: State) => groupByAmount(state.filters, (state.data.filterColumns == 0 ? 2 : state.data.filterColumns), (filter) => filter.fullWidth),
    filter: (state: State) => (id: string): Filter => state.filters.find(f => f.id === id) as Filter,
    filterQuery: (state: State) => (filterId: string): FilterQuery<any> | undefined => {
        return state.query.filterQueries.hasOwnProperty(filterId) ? state.query.filterQueries[filterId] : undefined;
    },
    filterQueries: (state: State): { [filterId: string]: FilterQuery<any> } => state.query.filterQueries,
    searchFilterQuery: (state: State, getters: GetterTree<State, any>): string => {
        const filterQueries = getters.filterQueries as unknown as { [filterId: string]: FilterQuery<any> };
        for (const filterId of Object.keys(filterQueries)) {
            const query = filterQueries[filterId];

            if (typeof query.value === 'string' || query.value instanceof String) {
                return query.value as string;
            }
        }

        return '';
    },
    pager: (state: State) => state.pager,
    results: (state: State) => state.results,
    counter: (state: State) => state.counter,
    query: (state: State): Query => state.query,
    pagingOptions: (state: State, getters: GetterTree<State, any>) => (getters.query as unknown as Query).pagingOptions,
    filterIsActive: (state: State) => (filterId: string): boolean => state.activeFilterId === filterId,
    filterIsInactive: (state: State) => (filterId: string): boolean => {
        return state.activeFilterId !== '' && state.activeFilterId !== filterId;
    },
    selectedFacets: (state: State, getters: GetterTree<State, any>): { [filterId: string]: Facet[] } => {
        const filterQueries = getters.filterQueries as unknown as { [filterId: string]: FilterQuery<any> };
        const result = {} as { [filterId: string]: Facet[] };

        for (const filterId in filterQueries) {
            if (filterQueries.hasOwnProperty(filterId)) {
                const filter = state.filters.find(f => f.id === filterId) as Filter;

                if ('facets' in filter) {
                    const facetFilter = filter as FacetFilter;
                    const selectedFacets = [] as Facet[];

                    for (const facet of facetFilter.facets) {
                        // If this facet exists in any FacetFilter query
                        if (filterQueries[filterId].value.indexOf(facet.id) !== -1) {
                            selectedFacets.push(facet);
                        }
                    }

                    result[filterId] = selectedFacets;
                }
            }
        }

        return result;
    }
};
